import { render, staticRenderFns } from "./AddMedicalFile.vue?vue&type=template&id=2949723f&scoped=true"
import script from "./AddMedicalFile.vue?vue&type=script&lang=js"
export * from "./AddMedicalFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2949723f",
  null
  
)

export default component.exports